module.exports = __webpack_public_path__ + "media/images/users/user-6-5dbd99c3ac8a126e8d7c5d525dc210d8.jpg";